import erro404 from './404.svg';
import faq from './faq.svg';
import paysucessul from './paysucessul.svg';
import ConferirPayShared from './ConferirPayShared.svg';
import email from './email.svg';

export const ALL_ILLUSTRATIONS = {
  erro404,
  faq,
  paysucessul,
  ConferirPayShared,
  email,
};
